import { useAuthStore } from '@/stores/AuthStore';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [{ path: '', component: () => import('pages/LoginPage.vue') }],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    beforeEnter: async () => {
      const authStore = useAuthStore();
      if (authStore.user == null) {
        await authStore.getUserDetails();
      }
    },
    children: [
      { path: '', component: () => import('pages/DashboardPage.vue') },
      { path: 'expenses', component: () => import('pages/ExpensePage.vue') },
      { path: 'recurring', component: () => import('pages/RecurringPage.vue') },
      { path: 'monthly-budget', component: () => import('pages/MonthlyBudgetPage.vue') },
      { path: 'profile', component: () => import('pages/ProfilePage.vue') },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
